import { FlowPickerComponent } from './flow-picker/flow-picker.component';
import { FallbackTranslationProvider } from './../providers/fallbacktranslation.provider';
import { FlowEngineModule } from './flow-engine/flow-engine.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app/app.component'
import { NavMenuComponent } from './navmenu/navmenu.component';
import { HomeComponent } from './home/home.component';
import { FetchDataComponent } from './fetchdata/fetchdata.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NodeComponent } from './node/node.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from './node-info/node-info.component';
import { NodeTypeComponent } from './node-type/node-type.component';
import {DndModule} from 'ng2-dnd';
import { PromptComponent } from './prompt/prompt.component';
import { TranslationModule, LocaleService, TranslationService } from 'angular-l10n';
import { ToolboxComponent } from './toolbox/toolbox.component';
import { ConnectionFilterPipe } from './connection-filter.pipe';
import { MetadataControlsComponent } from './metadata-controls/metadata-controls.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ConnectionComponent } from './connection/connection.component';
import { AuthComponent } from './auth/auth.component';
import { AuthService } from "services/auth.service";
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { MessageboxComponent } from './messagebox/messagebox.component';
import { ResourcesEditorComponent } from './resources-editor/resources-editor.component';
import { ResourceColumnComponent } from './resource-column/resource-column.component';

@NgModule({
    bootstrap: [ AppComponent ],
    declarations: [
        AppComponent,
        NavMenuComponent,
        FetchDataComponent,
        HomeComponent,
        NodeComponent,
        NgbdModalContent,
        NodeTypeComponent,
        PromptComponent,
        ToolboxComponent,
        FlowPickerComponent,
        ConnectionFilterPipe,
        MetadataControlsComponent,
        ConnectionComponent,
        AuthComponent,
        AuthCallbackComponent,
        MessageboxComponent,
        ResourcesEditorComponent,
        ResourceColumnComponent
    ],
    entryComponents:[NgbdModalContent,PromptComponent,MessageboxComponent,ResourcesEditorComponent],
    imports: [
        NgbModule.forRoot(),
        BrowserModule,
        FormsModule,
        DndModule.forRoot(),
        HttpModule,
        FlexLayoutModule,
        TranslationModule.forRoot({translationProvider: FallbackTranslationProvider}),
        FlowEngineModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'fetch-data/:id', component: FetchDataComponent },
            { path: 'auth', component: AuthComponent, canActivate: [AuthService] },
            { path: 'auth-callback', component: AuthCallbackComponent },
            { path: '**', redirectTo: 'home' },
        ],
        {
            useHash: true,
        })
    ],
    providers: [AuthService]
})
export class AppModule {
    constructor(public locale:LocaleService, public translation:TranslationService) {
        this.locale.addConfiguration()
            .addLanguages(['en', 'en-GB', 'nl'])
            .setCookieExpiration(30)
            .defineCurrency('EUR');
        this.locale.init();

        this.translation.addConfiguration()
            .addCustomProvider({type: 'global', path: './assets/global'})
            .addCustomProvider({type: 'lang', path: './assets/lang-'})
            .addCustomProvider({type: 'locale', path: './assets/locale-'});
        this.translation.init();
    }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/app.module.ts